import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { LoaderComponent } from '../../../../common-component/loader/loader.component';
import { DpTableComponent } from '../../../../common-component/dp-table/dp-table.component';
import { PrivilegeCellComponent } from '../../../../table-cell/privilege-cell.component';
import { PermissionsButtonComponent } from '../../../../table-cell/manage-userPermission-button-cell.component';
import { ManageUserRolesCellComponent } from '../../../../table-cell/manage-user-roles-cell.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonUtilService } from '../../../../services/common-util/common-util.service';
import { ToastrService } from 'ngx-toastr';
import { ManageUserService } from '../../../../services/raintree/Transmission/manage-user.service';
import { PermissionList } from '../../../../services/raintree/interfaces/manage-user';
import { forkJoin, map } from 'rxjs';
import { response } from 'express';
import { StateDistrictDialogComponent } from '../state-district-dialog/state-district-dialog.component';
import { PermissionViewerComponent } from "../permission-viewer/permission-viewer.component";
import { StateDistrictPopupComponent } from '../../../../manage-user/state-district-popup/state-district-popup.component';
import { SaveConfirmManageUserComponent } from '../save-confirm-manage-user/save-confirm-manage-user.component';
import { AppConfigService } from '../../../../services/config/app-config.service';
import { SatesListService } from '../../../../services/raintree/Transmission/sates-list.service';
import { DistrictListService } from '../../../../services/raintree/Transmission/district-list.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ManageUserPermissionDialogComponent } from '../manage-userPermission-dialog/manage-userPermission-dialog.component';
import { ManageUserDetailsDialogComponent } from '../manage-userDetails-dialog/manage-userDetails-dialog.component';
import { fail } from 'node:assert';
import { ManageNewRoleDialogComponent } from '../manage-newRole-dialog/manage-newRole-dialog.component';

interface Permission {
  id: number;
  name: string;
  status: string;
  viewHId: number;
}

interface Permission2 {
  id: number;
  name: string;
  status?: boolean;
  vhp_id: number;
  is_default: number;
  is_optional: number;
}
interface mergedPermission {
  id: number;
  name: string;
  states: { state_name: string; districts: string[] }[];
  states_perm?: { state_name: string; districts: string[] }[];
  role_id?: any;
}

interface Subview {
  key: number;
  permission: Permission[];
  viewName: string;
  labelName: string;
  country: string;
  state: string;
  district: string;
  level: number;
  role_id: number;
  status: string;
  subview: Subview[];
}

interface Subview2 {
  dwh_id: number;
  dvp_permission_name: Permission2[];
  view_name: string;
  view_label: string;
  dwh_parent_view_id: number;
  drm_id: number;
}

interface MergedSubview {
  key: number;
  permission: mergedPermission[];
  viewName: string;
  labelName: string;
  role_id: number;
  subview: MergedSubview[];
}

interface newPerm {
  country: string;
  state: string;
  district: string;
  roleId: number;
  key: number;
  permissionId: number;
  viewHId: number | null;
  status: string;
  isNew: boolean;
}
interface newPerm2 {
  country: string;
  states: {
    state_name: string;
    districts: string[];
  }[];
  roleId: number;
  key: number;
  permissionId: number;
  viewHId: number;
  status: string;
  // isNew:boolean;
}
interface RoleIdMap {
  level: string,
  role_id: number
}

const roleLevelMap : { [key: string]: string } = {
  "Report Admin": "REPORT LEVEL",
  "Super User": "SPECIAL LEVEL",
  "Adhurjya Worker": "ADHURJYA WORKER",
  "Jajak Worker": "JAJAK WORKER",
  "SPR Worker": "PR/SPR WORKER",
  "Prati Ritwik Worker": "PR/SPR WORKER",
  "State Level User": "STATE LEVEL",
  "District Level User": "DISTRICT LEVEL",
  "Field Level User": "FIELD LEVEL",
  "DP Entry User": "DP ENTRY USER"
};

const restrictedLevel = ["ADHURJYA WORKER", "JAJAK WORKER", "PR/SPR WORKER", "SPECIAL LEVEL", "DP ENTRY USER"];

const districtReqRoles: string[] = ["FIELD LEVEL", "DISTRICT LEVEL", "JAJAK WORKER", "ADHURJYA WORKER", "PR/SPR WORKER", "UK WORKER", "MANDIR WORKER", "KENDRA WORKER", "DP ENTRY USER"];
const stateReqRoles: string[] = ["STATE LEVEL"];
const optionalAreaReqRoles: string[] = ["REPORT LEVEL"]
const noAreaReqRoles: string[] = ["SPECIAL LEVEL"]
@Component({
  selector: 'app-manage-user-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    CommonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    LoaderComponent,
    ReactiveFormsModule,
    FormsModule,
    InfiniteScrollModule,
    DpTableComponent
  ],
  templateUrl: './manage-user-dialog.component.html',
  styleUrls: [
    './manage-user-dialog.component.scss',
    '../../../../../styles/_dropdown.scss',
  ],
})

export class ManageUserDialogComponent implements OnInit {
  isMobileView: boolean = false;
  statusActive: boolean = false;
  userPrivilege: boolean = false;
  userForm!: FormGroup;
  userPermissionList: Subview[] = [];
  processedUserPermissionList: newPerm2[] = [];
  processedInactivePermissionList: newPerm2[] = [];
  showPermissions: MergedSubview[] = [];
  isLoading: boolean = false;
  userData: any;
  changedPermissions: newPerm[] = [];
  managerPermission: Subview2[] = [];
  showLabel: { [key: number]: string } = {};
  parentMap: { [key: number]: number } = {};
  childMap: { [key: number]: number[] } = {};
  viewHids: any[] = [];
  user_role: string = '';
  roles!: RoleIdMap[];
  levels: string[] = ["ALL LEVEL"];
  selectedLevel: string = "ALL LEVEL";
  roleList: any[] = [];
  permissionList: any[] = [];
  roleLocationData: any = [];
  rolePermissionList: any = [];
  public displayColumnData: any = [];
  selectRole = new FormControl([Validators.required]);
  role_id!: number;
  permissionArray: any = [];
  allStates: any[] = [];
  allDistrict: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private isMobile: CommonUtilService,
    private toaster: ToastrService,
    private _manageUserService: ManageUserService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ManageUserDialogComponent>,
    private appConfigService: AppConfigService,
    private stateTransmissionService: SatesListService,
    private districtListService: DistrictListService,
  ) { }
  manageUserPermALL: any = []
  manageUserPermWithLoc: any = []
  ngOnInit(): void {
    this.isLoading = true;
    this.isMobileView = this.isMobile.isMobileDevice();
    this.stateTransmissionService.getStatesList().subscribe((res) => {
      res.data.forEach((item: any) => {
        this.allStates.push(item.stateName);
      })
    });
    if (this.data.userDetails.status.toLowerCase() === 'active') {
      this.statusActive = true;
    }
    if (this.data.userDetails.privilege.toLowerCase() === 'unblocked') {
      this.userPrivilege = true;
    }
    this.userForm = new FormGroup({
      userStatus: new FormControl(this.statusActive),
      userPrivilege: new FormControl(this.userPrivilege)
    });
    if (!this.data.isSuperUser) {
      this.userForm.get('userPrivilege')?.disable();
      // this.userForm.get('userStatus')?.disable();
    }
    this.loadPermissionLevels();
    this.userData = this.data.userDetails;
    // this.loadUserRoleLocationList();
    this.isLoading = false;
    if (this.userData.showPermissionLevel)
      this.onSelectLevel(this.userData.showPermissionLevel as string)
  }
  closeDialog() {
    this.dialogRef.close(true);
  }
  cellComponentMap = {
    permissions: ManageUserRolesCellComponent
  };
  openPermissionDialog(rowData: any) {
    const paramObj = {
      id: rowData.id,
    };
    this.isLoading = true;
    this._manageUserService.fetchUserRolePermissions(paramObj).subscribe({
      next: (response: any) => {
        if (response.data) {
          this.rolePermissionList = response.data
        }
        this.isLoading = false;
        const dialogRef = this.dialog.open(ManageUserPermissionDialogComponent, {
          data: {
            userDetails: this.data.userDetails,
            roleDetails: rowData,
            roleLocationId: rowData.id,
            rolePermissionList: this.rolePermissionList
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          if (result) this.loadUserRoleLocationList()
        });
      },
      error: (error: any) => {
        this.isLoading = false;
        this.toaster.error(error);
      },
    })
  }
  openUserDetailsDialog() {
    const dialogRef = this.dialog.open(ManageUserDetailsDialogComponent, {
      data: {
        userDetails: this.data.userDetails,
        isSuperUser: this.data.isSuperUser
      }
    });
  }
  openNewRoleDialog() {
    if (this.selectedLevel == "ALL LEVEL" || (restrictedLevel.includes(this.selectedLevel) && !this.data.isSuperUser)) {
      this.toaster.error(`${this.selectedLevel} not supported`);
    } else {
      const dialogRef = this.dialog.open(ManageNewRoleDialogComponent, {
        data: {
          userDetails: this.data.userDetails,
          states: this.data.states,
          districts: this.data.districts,
          level: this.selectedLevel,
          districtReqRoles: districtReqRoles,
          stateReqRoles: stateReqRoles,
          optionalAreaReqRoles: optionalAreaReqRoles,
          noAreaReqRoles: noAreaReqRoles,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) this.loadUserRoleLocationList()
      });
    }
  }
  removeExistingRole(rowData: any) {
    // role: "Field Level User"
    if (restrictedLevel.includes(this.selectedLevel) && !this.data.isSuperUser) {
      this.toaster.error(`${this.selectedLevel} not supported`);
      return;
    }
    let levelToRemove = roleLevelMap[rowData.role];
    const bodyObj = {
      newLoc_state: rowData.state,
      newLoc_district: rowData.district,
      roleId: levelToRemove,
      workerType: rowData.role,
    }
    this._manageUserService.removeExistingRole(this.data.userDetails.id, bodyObj).subscribe({
      next: (response) => {
        if (!response.error) {
          this.isLoading = false;
          this.loadUserRoleLocationList()
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.toaster.error(error);
      }
    });
  }
  onManageUserCellClick(event: any, type: any) {
    if (type === 'showPermissions' || event.actionType === 'showPermissions') {
      this.openPermissionDialog(event.rowData);
    } else if (type === 'delete' || event.actionType === 'delete') {
      this.removeExistingRole(event.rowData);
    }
  }
  loadPermissionLevels() {
    this._manageUserService.fetchManagablePermissionLevels().subscribe({
      next: (response: any) => {
        if (response.data) {
          this.levels.push(...response.data);
        }
      },
      error: (error: any) => {
        this.isLoading = false;
        this.toaster.error(error);
      },
    })
  }
  loadUserRoleLocationList() {
    const paramObj = {
      id: this.userData.id,
      type: this.selectedLevel
    };
    this.isLoading = true;
    this._manageUserService.fetchUserRoleLocations(paramObj).subscribe({
      next: (response: any) => {
        if (response.data) {
          let userRoles = response.data;
          const updatedArray = userRoles.map((obj: any) => {
            return {
              ...obj,
              durlm_district: obj.durlm_district === null ? 'ALL' : obj.durlm_district,
              durlm_state: obj.durlm_state === null ? 'ALL' : obj.durlm_state
            };
          });
          this.roleList = updatedArray
        }
        this.roleLocationData = this.roleList.map((item: any) => ({
          id: item.durlm_id,
          country: item.durlm_country,
          state: item.durlm_state,
          district: item.durlm_district,
          role: item.drm_role_name
        }));
        this.displayColumnData = [
          {
            id: 'country',
            name: 'Country',
          }, {
            id: 'state',
            name: 'State',
          }, {
            id: 'district',
            name: 'District',
          }, {
            id: 'role',
            name: 'Role',
          }, {
            id: 'permissions',
            name: '',
          },
        ];
        if (this.selectedLevel == "STATE LEVEL") {
          this.displayColumnData = [
            {
              id: 'country',
              name: 'Country',
            }, {
              id: 'state',
              name: 'State',
            }, {
              id: 'role',
              name: 'Role',
            }, {
              id: 'permissions',
              name: '',
            },
          ];
        }
        if (this.selectedLevel == "SPECIAL LEVEL") {
          this.displayColumnData = [
            {
              id: 'country',
              name: 'Country',
            }, {
              id: 'role',
              name: 'Role',
            }, {
              id: 'permissions',
              name: '',
            },
          ];
        }
        this.isLoading = false;
      },
      error: (error: any) => {
        this.isLoading = false;
        this.toaster.error(error);
      },
    })
  }
  flattenPermissions(): newPerm2[] {
    const flatPermissions: newPerm2[] = [];
    const flatInactivePermissions: newPerm2[] = [];
    const viewHids: any[] = [];
    const stateList = this.data.states;
    const districtList = this.data.districts;
    function processSubview(subview: Subview) {
      if (stateList.includes(subview.state) && districtList[subview.state]?.includes(subview.district)) {
        subview.permission.forEach(perm => {
          if (perm.status === 'Active') {
            const existingEntry = flatPermissions.find(entry =>
              entry.country === subview.country &&
              entry.roleId === subview.role_id &&
              entry.key === subview.key &&
              entry.permissionId === perm.id
            );
            if (existingEntry) {
              const stateEntry = existingEntry.states.find(state => state.state_name === subview.state);
              if (stateEntry) {
                if (!stateEntry.districts.includes(subview.district)) {
                  stateEntry.districts.push(subview.district);
                  viewHids.push({
                    key: subview.key,
                    id: perm.id,
                    state: subview.state,
                    district: subview.district,
                    viewHid: perm.viewHId,
                  });
                }
              } else {
                existingEntry.states.push({
                  state_name: subview.state,
                  districts: [subview.district]
                });
                viewHids.push({
                  key: subview.key,
                  id: perm.id,
                  state: subview.state,
                  district: subview.district,
                  viewHid: perm.viewHId,
                });
              }
            } else {
              flatPermissions.push({
                country: subview.country,
                states: [{
                  state_name: subview.state,
                  districts: [subview.district]
                }],
                roleId: subview.role_id,
                key: subview.key,
                permissionId: perm.id,
                viewHId: perm.viewHId,
                status: perm.status
              });
              viewHids.push({
                key: subview.key,
                id: perm.id,
                state: subview.state,
                district: subview.district,
                viewHid: perm.viewHId,
              });
            }
          }
          else if (perm.status == 'In-Active') {
            const existingEntry = flatInactivePermissions.find(entry =>
              entry.country === subview.country &&
              entry.roleId === subview.role_id &&
              entry.key === subview.key &&
              entry.permissionId === perm.id
            );
            if (existingEntry) {
              const stateEntry = existingEntry.states.find(state => state.state_name === subview.state);
              if (stateEntry) {
                if (!stateEntry.districts.includes(subview.district)) {
                  stateEntry.districts.push(subview.district);
                  viewHids.push({
                    key: subview.key,
                    id: perm.id,
                    state: subview.state,
                    district: subview.district,
                    viewHid: perm.viewHId,
                  });
                }
              } else {
                existingEntry.states.push({
                  state_name: subview.state,
                  districts: [subview.district]
                });
                viewHids.push({
                  key: subview.key,
                  id: perm.id,
                  state: subview.state,
                  district: subview.district,
                  viewHid: perm.viewHId,
                });
              }
            } else {
              flatInactivePermissions.push({
                country: subview.country,
                states: [{
                  state_name: subview.state,
                  districts: [subview.district]
                }],
                roleId: subview.role_id,
                key: subview.key,
                permissionId: perm.id,
                viewHId: perm.viewHId,
                status: perm.status
              });
              viewHids.push({
                key: subview.key,
                id: perm.id,
                state: subview.state,
                district: subview.district,
                viewHid: perm.viewHId,
              });
            }
          }
        });
        subview.subview.forEach(subSubview => processSubview(subSubview));
      }
    }
    this.userPermissionList.forEach(view => processSubview(view));
    this.processedInactivePermissionList = flatInactivePermissions;
    this.viewHids = viewHids;
    return flatPermissions;
  }
  // mergePermissions(permissions: Permission2[],mergedPerm: mergedPermission[],view_key:number): mergedPermission[] {
  //   permissions.forEach((perm)=>{
  //     const existingPerm= mergedPerm.find((perm_)=> perm_.id===perm.id);
  //     if(!existingPerm){
  //       const userSamePerm=  this.processedUserPermissionList.find(perm_=> perm_.key===view_key && perm_.permissionId===perm.id);
  //       if(userSamePerm && userSamePerm.status=='Active'){
  //         mergedPerm.push({
  //           id: perm.id,
  //           name: perm.name,
  //           states: userSamePerm.states,
  //         });
  //       }
  //       else{
  //         mergedPerm.push({
  //           id: perm.id,
  //           name: perm.name,
  //           states: [],
  //         });
  //       }
  //     }
  //   });
  //   return mergedPerm;
  // }
  processPermission(permissions: Permission2[], view_key: number): mergedPermission[] {
    const mergePerm: mergedPermission[] = permissions.map((perm) => {
      const userSamePerm = this.processedUserPermissionList.find(perm_ => perm_.key === view_key && perm_.permissionId === perm.id);
      if (userSamePerm && userSamePerm.status == 'Active') {
        return {
          id: perm.id,
          name: perm.name,
          states: userSamePerm.states,
        };
      }
      else {
        return {
          id: perm.id,
          name: perm.name,
          states: [],
        };
      }
    });
    return mergePerm;
  }
  mergeSubView(data: Subview2[]): MergedSubview[] {
    // const parentMap: {[key:number]:number}={};
    const view_label_map: { [key: number]: string } = {};
    const finalView: MergedSubview[] = data.map((view) => {
      this.parentMap[view.dwh_id] = view.dwh_parent_view_id;
      if (view.dwh_parent_view_id !== 0) {
        if (!this.childMap[view.dwh_parent_view_id]) this.childMap[view.dwh_parent_view_id] = [];
        if (!this.childMap[view.dwh_parent_view_id].includes(view.dwh_id)) this.childMap[view.dwh_parent_view_id].push(view.dwh_id);
      }
      view_label_map[view.dwh_id] = view.view_label;
      return {
        key: view.dwh_id,
        permission: this.processPermission(view.dvp_permission_name, view.dwh_id),
        viewName: view.view_name,
        labelName: view.view_label,
        role_id: view.drm_id,
        subview: [],
      }
    });
    const showLabelMap: { [key: number]: string } = {};
    data.forEach((view) => {
      let labelName: string = view.view_label;
      //   let parent: number=view.dwh_parent_view_id;
      //   if(Object.keys(view_label_map).includes(String(parent))){
      //     while(parent!=0){
      //       let parent_label= view_label_map[parent];
      //       parent=this.parentMap[parent];
      //       labelName=parent_label+" > "+labelName;
      //       }
      //     }
      showLabelMap[view.dwh_id] = labelName;
    });
    this.showLabel = showLabelMap;
    return finalView;
    // const viewMap: { [key: string]: MergedSubview } = {};
    // data.forEach((item) => {
    //   const key = item.viewName;
    //   if (!viewMap[key]) {
    //     const sameViewData= data.filter((view:Subview2)=> view.key===item.key);
    //     let permissionUnion: mergedPermission[]=[];
    //     let subviewUnion: Subview2[]=[];
    //     sameViewData.forEach((view:Subview2)=>{
    //       permissionUnion= this.mergePermissions(view.permission,permissionUnion,item.key);
    //       subviewUnion=subviewUnion.concat(view.subview);
    //     })
    //     viewMap[key] = {
    //       key: item.key,
    //       permission: permissionUnion,
    //       viewName: item.viewName,
    //       labelName: item.labelName,
    //       role_id: item.role_id,
    //       subview: this.mergeSubView(subviewUnion),
    //     };
    //   }
    // });
    // return Object.values(viewMap);
  }
  onStatusToggle(event: any): void {
    this.isLoading = true;
    const bodyObj = {
      verify: this.userForm.get('userStatus')?.value,
    }
    this._manageUserService.updatePermissions(this.data.userDetails.id, bodyObj).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.userData.status === 'Active' ? this.userData.status = 'Inactive' : this.userData.status = 'Active';
      },
      error: (error) => {
        this.isLoading = false;
        this.toaster.error(error);
      }
    });
  }
  onPrivilegeToggle(event: any): void {
    this.isLoading = true;
    const bodyObj = {
      block: !this.userForm.get('userPrivilege')?.value,
    }
    this._manageUserService.updatePermissions(this.data.userDetails.id, bodyObj).subscribe({
      next: (response) => {
        this.isLoading = false;
        this.userData.privilege === 'Blocked' ? this.userData.privilege = 'Unblocked' : this.userData.privilege = 'Blocked';
      },
      error: (error) => {
        this.isLoading = false;
        this.toaster.error(error);
      }
    });
  }
  onSelectLevel(selectedLevel: string) {
    this.selectedLevel = selectedLevel;
    this.loadUserRoleLocationList();
  }
}